import { HHTooltip } from '@hinge-health/react-component-library';
import { PlayCircleRounded } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { actionButtonText } from '../../constants/rules.constant';

// The Run modal is owned by the grid (useRuleActionModals), not the cell
export const RunRuleButton = ({
  onClick,
  runRuleLoading,
}: {
  onClick: () => void;
  runRuleLoading: boolean;
}): JSX.Element => (
  <HHTooltip hhVariant="bottom" title={actionButtonText.run}>
    <GridActionsCellItem
      id="run-rule-button"
      data-testid="run-rule-button"
      label={actionButtonText.run}
      icon={<PlayCircleRounded />}
      color="primary"
      onClick={onClick}
      disabled={runRuleLoading}
    />
  </HHTooltip>
);
